import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;
interface LPExperienceQueryParams {
  oauthTokenHeader: string;
  queryId: string;
  startDate: string;
  endDate: string;
  timeUnit: string;
  websiteSharedUid: string; // Single
  account_shared_uid: string; // Single
  dimensions?: any; // Multiple
  type: string; // Single required
  matchtype?: string; // Optional single
  kwInternalId?: string | any; // Optional single
  country?: string; // Optional single
  traffic_source?: string | any; // Optional single
  campaign_status?: string | any; // Optional single
  platformAccountId?: any;
  campaignId?: string;
  page_shared_uid?: any;
  campaign_id?: any;
  dimension?: any;
  website_page_id?: any;
  website_page_shared_uid?: any;
}
function getAllAccounts(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/advertising_management/advertising_accounts/`,
    oauthTokenHeader
  );
}

function getLPCampaignExecuteQuery(params: LPExperienceQueryParams) {
  const {
    oauthTokenHeader,
    queryId,
    startDate,
    endDate,
    websiteSharedUid,
    account_shared_uid,
    dimensions,
    type,
    traffic_source,
    campaign_status,
  } = params;

  const searchParams = new URLSearchParams();

  // Required params
  searchParams.append("website_shared_uid", websiteSharedUid);
  searchParams.append("start_date", startDate);
  searchParams.append("end_date", endDate);
  searchParams.append("type", type);
  searchParams.append("traffic_source", traffic_source);
  searchParams.append("account_shared_uid", account_shared_uid);
  searchParams.append("campaign_status", campaign_status);
  dimensions.forEach((dim: any) =>
    searchParams.append("dimension", dim.dimension_name)
  );

  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;

  return fetchWrapper.get(fullUrl, oauthTokenHeader);
}
function getCostWeightedScoreChart(params: LPExperienceQueryParams) {
  const {
    oauthTokenHeader,
    queryId,
    startDate,
    endDate,
    websiteSharedUid,
    dimensions,
    type,
    platformAccountId,
    campaignId,
    kwInternalId,
  } = params;

  const searchParams = new URLSearchParams();
  searchParams.append("website_shared_uid", websiteSharedUid);
  searchParams.append("start_date", startDate);
  searchParams.append("end_date", endDate);
  searchParams.append("type", type);
  searchParams.append("platform_account_id", platformAccountId);
  dimensions.forEach((dim: any) =>
    searchParams.append("dimension", dim.dimension_name)
  );
  searchParams.append("kw_internal_id", kwInternalId);

  if (campaignId) searchParams.append("campaign_id", campaignId);

  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;
  return fetchWrapper.get(fullUrl, oauthTokenHeader);
}

function getPerformanceByKeyword(params: LPExperienceQueryParams) {
  const {
    oauthTokenHeader,
    queryId,
    startDate,
    endDate,
    websiteSharedUid,
    //dimensions,
    // type,
    platformAccountId,
    campaignId,
    kwInternalId,
  } = params;

  const searchParams = new URLSearchParams();
  searchParams.append("website_shared_uid", websiteSharedUid);
  searchParams.append("start_date", startDate);
  searchParams.append("end_date", endDate);
  // searchParams.append("type", type);
  searchParams.append("platform_account_id", platformAccountId);
  //  searchParams.append("dimension", dimensions);
  searchParams.append("keyword_internal_id", kwInternalId);

  if (campaignId) searchParams.append("campaign_id", campaignId);

  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;
  return fetchWrapper.get(fullUrl, oauthTokenHeader);
}

function getSingleKeywordDetailsByInternalId(params: LPExperienceQueryParams) {
  const {
    oauthTokenHeader,
    queryId,
    startDate,
    endDate,
    websiteSharedUid,
    kwInternalId,
    page_shared_uid,
    type,
  } = params;

  const searchParams = new URLSearchParams();
  searchParams.append("website_shared_uid", websiteSharedUid);
  searchParams.append("start_date", startDate);
  searchParams.append("end_date", endDate);
  searchParams.append("keyword_internal_id", kwInternalId);
  searchParams.append("page_shared_uid", page_shared_uid);
  searchParams.append("type", type);

  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;
  return fetchWrapper.get(fullUrl, oauthTokenHeader);
}

function getKeywordsLinkedToURL(params: LPExperienceQueryParams) {
  const {
    oauthTokenHeader,
    queryId,
    startDate,
    endDate,
    websiteSharedUid,
    kwInternalId,
    page_shared_uid,
  } = params;

  const searchParams = new URLSearchParams();
  searchParams.append("website_shared_uid", websiteSharedUid);
  searchParams.append("start_date", startDate);
  searchParams.append("end_date", endDate);
  searchParams.append("keyword_internal_id", kwInternalId);
  searchParams.append("page_shared_uid", page_shared_uid);

  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;
  return fetchWrapper.get(fullUrl, oauthTokenHeader);
}

function getSingleKeywordDetails(params: LPExperienceQueryParams) {
  const {
    oauthTokenHeader,
    queryId,
    startDate,
    endDate,
    websiteSharedUid,
    kwInternalId,
    platformAccountId,
    campaign_id,
  } = params;

  const searchParams = new URLSearchParams();
  searchParams.append("website_shared_uid", websiteSharedUid);
  searchParams.append("start_date", startDate);
  searchParams.append("end_date", endDate);
  searchParams.append("keyword_internal_id", kwInternalId);
  searchParams.append("platform_account_id", platformAccountId);
  searchParams.append("campaign_id", campaign_id);

  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;
  return fetchWrapper.get(fullUrl, oauthTokenHeader);
}
function getDailyLPExperienceDetails(params: LPExperienceQueryParams) {
  const {
    oauthTokenHeader,
    queryId,
    startDate,
    endDate,
    websiteSharedUid,
    kwInternalId,
    platformAccountId,
    campaign_id,
    type,
    dimension,
  } = params;

  const searchParams = new URLSearchParams();
  searchParams.append("website_shared_uid", websiteSharedUid);
  searchParams.append("start_date", startDate);
  searchParams.append("end_date", endDate);
  searchParams.append("kw_internal_id", kwInternalId);
  searchParams.append("platform_account_id", platformAccountId);
  searchParams.append("campaign_id", campaign_id);
  searchParams.append("type", type);
  searchParams.append("dimension", dimension);

  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;
  return fetchWrapper.get(fullUrl, oauthTokenHeader);
}

function getKeywordReleventScore(params: LPExperienceQueryParams) {
  const { oauthTokenHeader, kwInternalId, website_page_id } = params;
  const searchParams = new URLSearchParams();
  searchParams.append("keyword_id", kwInternalId);
  searchParams.append("website_page_id", website_page_id);

  const url = new URL(
    `${apiUrl}/relevance-scorer/keyword-to-lp/?${searchParams.toString()}`
  );

  return fetchWrapper.get(url.toString(), oauthTokenHeader);
}

function postKeywordReleventScore(params: LPExperienceQueryParams, data: any) {
  const { oauthTokenHeader } = params;
  const searchParams = new URLSearchParams();

  const url = new URL(
    `${apiUrl}/relevance-scorer/keyword-to-lp/?${searchParams.toString()}`
  );

  return fetchWrapper.post(url.toString(), data, oauthTokenHeader);
}

function getCompetitorMetricsAccordion(params: LPExperienceQueryParams) {
  const {
    oauthTokenHeader,
    queryId,
    startDate,
    endDate,
    websiteSharedUid,
    kwInternalId,
  } = params;

  const searchParams = new URLSearchParams();
  searchParams.append("website_shared_uid", websiteSharedUid);
  searchParams.append("start_date", startDate);
  searchParams.append("end_date", endDate);
  searchParams.append("keyword_internal_id", kwInternalId);

  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;
  return fetchWrapper.get(fullUrl, oauthTokenHeader);
}

function getPageSpeedMetrics(params: LPExperienceQueryParams) {
  const {
    oauthTokenHeader,
    queryId,
    startDate,
    endDate,
    websiteSharedUid,
    website_page_shared_uid,
  } = params;

  const searchParams = new URLSearchParams();
  searchParams.append("website_shared_uid", websiteSharedUid);
  searchParams.append("start_date", startDate);
  searchParams.append("end_date", endDate);
  searchParams.append("website_page_shared_uid", website_page_shared_uid);

  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;
  return fetchWrapper.get(fullUrl, oauthTokenHeader);
}

function getEngagementMetrics(params: LPExperienceQueryParams) {
  const {
    oauthTokenHeader,
    queryId,
    startDate,
    endDate,
    websiteSharedUid,
    website_page_shared_uid,
  } = params;

  const searchParams = new URLSearchParams();
  searchParams.append("website_shared_uid", websiteSharedUid);
  searchParams.append("start_date", startDate);
  searchParams.append("end_date", endDate);
  searchParams.append("page_shared_uid", website_page_shared_uid);

  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;
  return fetchWrapper.get(fullUrl, oauthTokenHeader);
}

export const lpExperienceService = {
  getAllAccounts,
  getLPCampaignExecuteQuery,
  getCostWeightedScoreChart,
  getPerformanceByKeyword,
  getSingleKeywordDetailsByInternalId,
  getSingleKeywordDetails,
  getDailyLPExperienceDetails,
  getKeywordReleventScore,
  getCompetitorMetricsAccordion,
  getPageSpeedMetrics,
  getKeywordsLinkedToURL,
  postKeywordReleventScore,
  getEngagementMetrics,
};
